import { useMemo } from 'preact/hooks';

import { Product } from '@/queries/products/types';

import { ProductFeaturesList, ProductFeaturesListItem } from '../ProductFeatureList';
import { parseBenefits } from '../utils';

interface ProductCardBenefitsProps {
  /** The product whose Stripe metadata carries the list. */
  product: Product | undefined;
}

/**
 * The itemised entitlements, read from the product's `benefits` metadata in Stripe.
 *
 * That metadata is edited by hand, per environment, so "no list" is a state this will really be in:
 * the key missing, the JSON malformed, or an environment nobody got to. `parseBenefits` answers `[]`
 * to all three, and the panel then renders no list at all rather than an empty one — an empty `ul`
 * still costs the panel a gap, which reads as something failing to load.
 */
const ProductCardBenefits = ({ product }: ProductCardBenefitsProps) => {
  const benefits = useMemo(() => parseBenefits(product), [product]);
  if (benefits.length === 0) return null;
  return (
    <ProductFeaturesList className="w-full gap-[11px]">
      {benefits.map((benefit, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ProductFeaturesListItem key={index.toString()} className="text-sm/5">
          {benefit}
        </ProductFeaturesListItem>
      ))}
    </ProductFeaturesList>
  );
};

export default ProductCardBenefits;
